import { render } from "./UserImage.vue?vue&type=template&id=5215fea6"
import script from "./UserImage.vue?vue&type=script&lang=js"
export * from "./UserImage.vue?vue&type=script&lang=js"
script.render = render

export default script